import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Headers } from '@angular/http';

import { AppServices } from './../../app.services';
import { NotifyService } from './../../addon/notify.service';

import * as Highcharts from 'highcharts';
import * as HighchartsFunnel from 'highcharts/modules/funnel';
import * as Exporting from 'highcharts/modules/exporting';
Exporting(Highcharts)
HighchartsFunnel(Highcharts)

import * as _ from 'lodash';
import * as domtoimage from 'dom-to-image';

declare var $:any;

@Component({
	selector: 'app-lead',
	templateUrl: './lead.component.html',
	styleUrls: ['./lead.component.css']
})
export class LeadComponent implements OnInit {
	filter_lead = {};
	data_lead; lead;
	filter_contact = {};
	data_contact;
	filter_pic = {};
	data_pic;
	filter_member = {};
	data_member;
	filter_meeting = {};
	data_meeting;
	constructor(private router: Router, private appServices: AppServices, private notifyService: NotifyService) { }

	ngOnInit() {
		this.loadLead();
		this.loadChartPie();
	}
	assign(frm, data) {
		$.each(data, function(key){
			frm[key] = data[key];
		})
	}
	goTab(el) {
		$(`a[href="${el}"]`)[0].click();
	}
	getYT(frm, attr) {
		if(frm[attr]) {
			let code = frm[attr].split('v=')[1]
			frm[attr] = `https://www.youtube.com/embed/${code}?version=3&rel=0&modestbranding=1&autoplay=1&autohide=1&showinfo=0&controls=0&loop=1&enablejsapi=1&playlist=${code}`;
		} else {
			frm[attr] = 'https://www.youtube.com/embed/';
		}
	}
	getDrive(frm, attr) {
		if(frm[attr]) {
			frm[attr] = 'https://drive.google.com/uc?id=' + frm[attr].split('/')[5];
		} else {
			frm[attr] = 'https://drive.google.com/uc?id=';
		}
	}
	addInfo(frm, data, attr) {
		if(data) {
			if(!frm['info']) {
				frm['info'] = {};
			}
			frm['info'][attr].push(data)
		}
	}
	revInfo(frm, data, attr) {
		frm['info'][attr] = frm['info'][attr].filter(n => n != data)
	}

	loadChartPie() {
		this.appServices.api('Crmleads/group', {
			'filter': `{"where":${JSON.stringify(this.filter_lead)},"order":"created_dt desc"}`,
			'prop': 'group'
		}, this).then(function(obj){
			let json = obj.response.json();
			if(json.res.length > 0) {
				Highcharts.chart('chartPie', {
					chart: {
						type: 'pie'
					},
					title: {
						style: {
							display: 'none'
						}
					},
					plotOptions: {
						pie: {
							allowPointSelect: true,
							cursor: 'pointer',
							dataLabels: {
								enabled: false
							},
							showInLegend: true
						}
					},
					series: [{
						name: 'Group',
						data: json.res.map(el => {
							return {
								name: el.group,
								y: el.total
							}
						})
					}],
					credits: {
						enabled: false
					},
				});
			}
		}).catch(function(err){
			err.component.notifyService.show(err.err.json().error.message, 'danger');
		})
	}
	loadLead(param = null, add = false) {
		let filter = this.filter_lead;
		if(param) {
			filter = $.extend(filter, param);
			let paramIndex = Object.keys(filter).indexOf(Object.keys(param)[0]);
			if(!(Object.values(filter)[paramIndex])){
				delete filter[Object.keys(param)[0]];
			}
		}
		Object.assign(filter, {"deleted":false, "accountcode": this.appServices.accountcode})
		this.appServices.api('Crmleads/find', {
			'filter': `{"where":${JSON.stringify(filter)},"skip":${add ? this.data_lead.res.length : 0},"order":"created_dt desc"}`
		}, this).then(function(obj){
			let json = obj.response.json();
			if(add) {
				obj.component.data_lead.res = obj.component.data_lead.res.concat(json.res);
			} else {
				obj.component.data_lead = json;
			}
			obj.component.loadChartPie();
		}).catch(function(err){
			err.component.notifyService.show(err.err.json().error.message, 'danger');
		})
	}
	loadContact(param = null, add = false) {
		let filter = this.filter_contact;
		if(param) {
			filter = $.extend(filter, param);
			let paramIndex = Object.keys(filter).indexOf(Object.keys(param)[0]);
			if(!(Object.values(filter)[paramIndex])){
				delete filter[Object.keys(param)[0]];
			}
		}
		Object.assign(filter, {"deleted":false, "action": "contact"})
		this.appServices.api('Crmpeople/find', {
			'filter': `{"where":${JSON.stringify(filter)},"skip":${add ? this.data_contact.res.length : 0},"order":"created_dt desc"}`
		}, this).then(function(obj){
			let json = obj.response.json();
			if(add) {
				obj.component.data_contact.res = obj.component.data_contact.res.concat(json.res);
			} else {
				obj.component.data_contact = json;
			}
		}).catch(function(err){
			err.component.notifyService.show(err.err.json().error.message, 'danger');
		})
	}
	loadPIC(param = null, add = false) {
		let filter = this.filter_pic;
		if(param) {
			filter = $.extend(filter, param);
			let paramIndex = Object.keys(filter).indexOf(Object.keys(param)[0]);
			if(!(Object.values(filter)[paramIndex])){
				delete filter[Object.keys(param)[0]];
			}
		}
		Object.assign(filter, {"deleted":false, "action": "pic"})
		this.appServices.api('Crmpeople/find', {
			'filter': `{"where":${JSON.stringify(filter)},"skip":${add ? this.data_contact.res.length : 0},"order":"created_dt desc"}`
		}, this).then(function(obj){
			let json = obj.response.json();
			if(add) {
				obj.component.data_pic.res = obj.component.data_pic.res.concat(json.res);
			} else {
				obj.component.data_pic = json;
			}
		}).catch(function(err){
			err.component.notifyService.show(err.err.json().error.message, 'danger');
		})
	}
	loadMember(param = null, add = false) {
		let filter = this.filter_member;
		if(param) {
			filter = $.extend(filter, param);
			let paramIndex = Object.keys(filter).indexOf(Object.keys(param)[0]);
			if(!(Object.values(filter)[paramIndex])){
				delete filter[Object.keys(param)[0]];
			}
		}
		Object.assign(filter, {"deleted":false, "accountcode": this.appServices.accountcode})
		this.appServices.api('Members/find', {
			'filter': `{"where":${JSON.stringify(filter)},"skip":${add ? this.data_member.res.length : 0},"order":"created_dt desc"}`
		}, this).then(function(obj){
			let json = obj.response.json();
			if(add) {
				obj.component.data_member.res = obj.component.data_member.res.concat(json.res);
			} else {
				obj.component.data_member = json;
			}
		}).catch(function(err){
			err.component.notifyService.show(err.err.json().error.message, 'danger');
		})
	}
	loadMeeting(param = null, add = false) {
		let filter = this.filter_meeting;
		if(param) {
			filter = $.extend(filter, param);
			let paramIndex = Object.keys(filter).indexOf(Object.keys(param)[0]);
			if(!(Object.values(filter)[paramIndex])){
				delete filter[Object.keys(param)[0]];
			}
		}
		Object.assign(filter, {"deleted":false})
		this.appServices.api('Crmconferences/find', {
			'filter': `{"where":${JSON.stringify(filter)},"skip":${add ? this.data_meeting.res.length : 0},"order":"created_dt desc"}`
		}, this).then(function(obj){
			let json = obj.response.json();
			if(add) {
				obj.component.data_meeting.res = obj.component.data_meeting.res.concat(json.res);
			} else {
				obj.component.data_meeting = json;
			}
		}).catch(function(err){
			err.component.notifyService.show(err.err.json().error.message, 'danger');
		})
	}
	moreLead() {
		this.loadLead(this.filter_lead, true);
	}
	moreContact() {
		this.loadContact(this.filter_contact, true);
	}
	morePIC() {
		this.loadPIC(this.filter_pic, true);
	}
	moreMember() {
		this.loadMember(this.filter_member, true);
	}
	moreMeeting() {
		this.loadMeeting(this.filter_meeting, true);
	}
	saveLead(data) {
		data = _.pickBy(data)
		data['accountcode'] = this.appServices.accountcode;
		data['codemember'] = this.appServices.session[0].member.code;
		data['deleted'] = false
		data['info'] = data['info'] ? Object.assign(data['info'], {
			'debt_term': data['debt_term'] ? data['debt_term'] : '',
			'size': data['size'] ? data['size'] : '',
			'btype': data['btype'] ? data['btype'] : '',
			'capital': data['capital'] ? data['capital'] : '',
			'capital_currency': data['capital_currency'] ? data['capital_currency'] : ''
		}) : {};
		this.appServices.api('Crmleads/save', data, this).then(function(obj){
			let json = obj.response.json();
			obj.component.notifyService.show(obj.response.statusText)
			obj.component.loadLead();
		}).catch(function(err){
			err.component.notifyService.show(err.err.json().error.message, 'danger');
		})
	}
	saveContact(data) {
		data = _.pickBy(data)
		data['codelead'] = this.lead.code
		data['deleted'] = false
		data['info'] = {
			'department': data['department'] ? data['department'] : '',
			'position': data['position'] ? data['position'] : ''
		}
		data['action'] = 'contact'
		this.appServices.api('Crmpeople/save', data, this).then(function(obj){
			let json = obj.response.json();
			obj.component.notifyService.show(obj.response.statusText)
			obj.component.loadContact();
		}).catch(function(err){
			err.component.notifyService.show(err.err.json().error.message, 'danger');
		})
	}
	savePIC(data) {
		delete data['code']
		data = _.pickBy(data)
		data['deleted'] = false
		data['codelead'] = this.lead.code
		data['action'] = 'pic'
		this.appServices.api('Crmpeople/find', {
			'filter': `{"where":{"codelead": "${data.codelead}", "email": "${data.email}", "phone": "${data.phone}"}}`
		}, this).then(function(obj){
			let res = obj.response.json().res;
			if(res.length == 0) {
				obj.component.appServices.api('Crmpeople/save', data, obj.component).then(function(obj){
					let json = obj.response.json();
					obj.component.notifyService.show(obj.response.statusText)
					obj.component.loadPIC();
				}).catch(function(err){
					err.component.notifyService.show(err.err.json().error.message, 'danger');
				})
			} else {
				res[0]['deleted'] = false;
				obj.component.appServices.api('Crmpeople/save', res[0], obj.component).then(function(obj){
					let json = obj.response.json();
					obj.component.notifyService.show(obj.response.statusText)
					obj.component.loadPIC();
				}).catch(function(err){
					err.component.notifyService.show(err.err.json().error.message, 'danger');
				})
			}
		}).catch(function(err){
			err.component.notifyService.show(err.err.json().error.message, 'danger');
		})
	}
	revPic(data) {
		data['deleted'] = true;
		this.appServices.api('Crmpeople/save', data, this).then(function(obj){
			let json = obj.response.json();
			obj.component.notifyService.show(obj.response.statusText)
			obj.component.loadPIC();
		}).catch(function(err){
			err.component.notifyService.show(err.err.json().error.message, 'danger');
		})
	}
	saveMeeting(data) {
		data = _.pickBy(data)
		data['codelead'] = this.lead.code
		data['deleted'] = false
		data['email'] = {
			'to': data['to'],
			'cc': data['cc']
		}
		this.appServices.api('Crmconferences/save', data, this).then(function(obj){
			let json = obj.response.json();
			obj.component.notifyService.show(obj.response.statusText)
			obj.component.loadMeeting();
		}).catch(function(err){
			err.component.notifyService.show(err.err.json().error.message, 'danger');
		})
	}
	doSend(data) {
		this.appServices.api('Contacts/sendmail', {
			'to': [data.to],
			'cc': [data.cc],
			'subject': `${data.title} ${data.start_dt}`,
			'content': data.content
		}, this).then(function(obj){
			let res = obj.response.json().res;
			obj.component.notifyService.show(obj.response.statusText)
		}).catch(function(err){
			err.component.notifyService.show(err.err.json().error.message, 'danger');
		})
	}
}



// WEBPACK FOOTER //
// D:/wamp/www/sportal/pmi/web/src/app/main/lead/lead.component.ts